import { __assign, __extends } from "tslib";
import { CustomerAccountServiceLambdaServiceException as __BaseException } from "./CustomerAccountServiceLambdaServiceException";
export var CreateAccountRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateAccountResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var AccessDeniedException = (function (_super) {
    __extends(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "AccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        return _this;
    }
    return AccessDeniedException;
}(__BaseException));
export { AccessDeniedException };
var ConflictException = (function (_super) {
    __extends(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, __assign({ name: "ConflictException", $fault: "client" }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        return _this;
    }
    return ConflictException;
}(__BaseException));
export { ConflictException };
var InternalServerException = (function (_super) {
    __extends(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalServerException", $fault: "server" }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        return _this;
    }
    return InternalServerException;
}(__BaseException));
export { InternalServerException };
var InvalidRequestException = (function (_super) {
    __extends(InvalidRequestException, _super);
    function InvalidRequestException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidRequestException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidRequestException.prototype);
        return _this;
    }
    return InvalidRequestException;
}(__BaseException));
export { InvalidRequestException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
var ThrottlingException = (function (_super) {
    __extends(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, __assign({ name: "ThrottlingException", $fault: "client" }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        return _this;
    }
    return ThrottlingException;
}(__BaseException));
export { ThrottlingException };
export var ValidationExceptionFieldFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, __assign({ name: "ValidationException", $fault: "client" }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.fieldList = opts.fieldList;
        return _this;
    }
    return ValidationException;
}(__BaseException));
export { ValidationException };
export var ListAccountsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AccountFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListAccountsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateAccountRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateAccountResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEngagementsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EngagementFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEngagementsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListOpportunitiesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OpportunityFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListOpportunitiesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
